import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ConfigModule } from './modules/config/config.module';
import { RouterEffects } from './core/effects/router.effects';
import { CustomSerializer } from './core/router/custom-serializer';
import { SharedModule } from './modules/shared/shared.module';
import { reducers } from './app.store';
import { AppState } from './app.state';
import { storeFreeze } from 'ngrx-store-freeze';
import { UserEffects } from './core/effects/user.effects';
import { LanguageEffects } from './core/effects/language.effects';
import { LogoutEffects } from './core/effects/logout.effects';
import { UrlParamsModule } from './modules/url-params/url-params.module';
import { createClearReducer } from './core/reducers/meta/clear.reducer';
import { localStorageSyncReducer } from './core/reducers/meta/localStorageSync.reducer';
import { ErrorEffect } from './core/effects/error.effect';
import { MessagesEffect } from './core/effects/messages.effect';
import { CoreModule, createTranslateLoader } from './core/core.module';
import { ErrorComponent } from './components/error/error.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { MessagesComponent } from './components/messages/messages.component';
import { LogoutComponent } from './components/logout/logout.component';
import { PostMessageComponent } from './components/postmessage/post-message.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ExpiredComponent } from './components/expired/expired.component';
import { MepHandoverComponent } from './components/mep-handover/mep-handover.component';
import { parse } from './core/helpers/query-parser';
import { AppEffects } from './core/effects/app.effects';
import { AppNavigationComponent } from './components/app-navigation/app-navigation.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ConsentModule } from './modules/consent/consent.module';
import { BsDropdownModule, PaginationModule, TypeaheadModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ApplicationsModule } from './modules/applications/applications.module';
import * as auth from './core/actions/logout.actions';
import { LogoutScreenComponent } from './components/logout-screen/logout-screen.component';


let debug = false;

if (window) {
    let params = parse(window.location.toString());
    debug = params['debug'] === 'true';
}

const clear = createClearReducer(auth.LOGOUT);

export const metaReducers: MetaReducer<AppState>[] = debug
    ? [storeFreeze, localStorageSyncReducer, clear]
    : [localStorageSyncReducer, clear];

@NgModule({
    imports: [
        ConfigModule.forRoot(),
        UrlParamsModule.forRoot(),
        ConsentModule.forRoot(),
        ApplicationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        CoreModule.forRoot(),
        SharedModule.forRoot(),
        AlertModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        TooltipModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        TypeaheadModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        StoreModule.forRoot(reducers, { metaReducers }),
        EffectsModule.forRoot([
            AppEffects, RouterEffects, UserEffects, LogoutEffects, ErrorEffect, MessagesEffect, LanguageEffects
        ]),
        StoreRouterConnectingModule,
        debug ? StoreDevtoolsModule.instrument() : []
    ],
    declarations: [
        AppComponent,
        AppHeaderComponent,
        LogoutComponent,
        LogoutScreenComponent,
        AppNavigationComponent,
        MepHandoverComponent,
        MessagesComponent,
        PostMessageComponent,
        LoadingScreenComponent,
        ErrorComponent,
        UnauthorizedComponent,
        ExpiredComponent,
        NotFoundComponent
    ],
    providers: [
        { provide: RouterStateSerializer, useClass: CustomSerializer },
        // poll checker time setiings in milliseconds
        { provide: 'initDelay', useValue: 500 },    // initial delay before a request is fired
        { provide: 'repeatDelay', useValue: 1000 }, // delay between repeated requests
        { provide: 'maxRepeatCount', useValue: 5 }, // max number of repeats
        { provide: 'messagesDisplayTime', useValue: 10000 }, // messages display time in milliseconds
        { provide: 'debug', useValue: debug } // messages display time in milliseconds
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.module.ts